import { createActionGroup } from '@ngrx/store';
import { BookingProductType } from '@products/models/booking.model';

export const VoucherProductBookingActions = createActionGroup({
  source: 'Voucher Product Booking',
  events: {
    'Set voucher product in booking list': (bookingProductTypes: BookingProductType[]) => ({ bookingProductTypes }),
    'Set voucher for anonymous product in booking list': (bookingProductTypes: BookingProductType[]) => ({
      bookingProductTypes
    }),
    'Remove voucher product from booking list': (bookingProductTypes: BookingProductType[]) => ({
      bookingProductTypes
    }),
    'Remove released voucher product from booking list': (bookingProductTypes: BookingProductType[]) => ({
      bookingProductTypes
    })
  }
});
